// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { eachMinuteOfInterval as fn } from "../eachMinuteOfInterval.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const eachMinuteOfIntervalWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default eachMinuteOfIntervalWithOptions;
